import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Cómo funciona la rodillera térmica?',
    a: 'La rodillera cuenta con un sistema de calentamiento interno. Solo necesitas conectarla mediante su cable USB a cualquier fuente de energía (powerbank, cargador de celular o laptop), seleccionar uno de los 3 niveles de calor y colocarla en tu rodilla.'
  }, {
    q: '¿Es seguro el calor USB?',
    a: 'Totalmente seguro. Funciona con bajo voltaje (5V) y cuenta con protección contra sobrecalentamiento. Está diseñada para proporcionar un calor terapéutico constante sin riesgo de quemaduras.'
  }, {
    q: '¿Cuánto tarda el envío?',
    a: 'El envío es GRATIS a todo México. El tiempo de entrega estimado es de 2 a 5 días hábiles dependiendo de tu ubicación.'
  }, {
    q: '¿Puedo pagar contra entrega?',
    a: '¡Sí! Para tu mayor seguridad y confianza, ofrecemos la opción de Pago Contra Entrega. Pagas en efectivo directamente al repartidor cuando recibes el producto en tus manos.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí, ofrecemos una garantía de satisfacción de 30 días. Si el producto presenta algún defecto de fábrica o no cumple tus expectativas, te respaldamos.'
  }, {
    q: '¿Qué talla es?',
    a: 'Es unitalla. Cuenta con correas de velcro altamente ajustables que se adaptan cómodamente a la mayoría de los tamaños de pierna, tanto para hombres como para mujeres.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full bg-slate-50 py-16 px-4" data-id="element-49">
      <div className="max-w-3xl mx-auto" data-id="element-50">
        <div className="text-center mb-12" data-id="element-51">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-52">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-53">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-sm transition-all" data-id="element-54">
              <button onClick={() => toggleFaq(idx)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-55">
                <span className="font-bold text-slate-800 text-lg pr-4" data-id="element-56">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-blue-600 transform transition-transform duration-200 shrink-0 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-57" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === idx ? 'max-h-96 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-58">
                <p className="text-slate-600 leading-relaxed" data-id="element-59">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}